import React from "react";
import { useNavigate } from "react-router-dom";

import { changeMemberCertification } from "../../../services/memberServices";

import { useUserContext } from "../../../contexts/userContext";

import useIdentityVerification from "../../../hooks/useIdentityVerification";
import useFullScreenLoading from "../../../hooks/useFullScreenLoading";

import StickyHeader from "../../../components/Layout/StickyHeader";
import BottomButtonGroup from "../../../components/Button/Bottom";
import CommonPopup from "../../../components/Popup";
import CommonButton from "../../../components/Button";
import { AuthHeader } from "../../../components/Layout/Auth/Header";

import { FindIdInfoIcon } from "../../Auth/FindId";

type Props = {};

export default function MyInfoCertIdentity(props: Props) {
  const [
    { data: identityData, isComplete: isIdentityComplete },
    identityComponent,
  ] = useIdentityVerification({ needDuplicate: true });
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const loadingComponent = useFullScreenLoading({ isLoading });
  const [user] = useUserContext();
  const [popup, setPopup] = React.useState<string>("");

  return (
    <div className="px-5">
      {loadingComponent}
      <StickyHeader
        title="본인인증 다시하기"
        onBackClick={() => navigate("/myinfo")}
      />

      <AuthHeader ruleClassName="bg-brand-neutral-05">
        등록된 <span className="font-medium">번호 변경</span>을
        <br />
        도와드릴게요
        <div className="flex flex-col gap-1 text-brand-neutral-50 font-normal">
          <div className="text-base">
            번호 변경을 위해서 인증이 다시 필요해요
          </div>
        </div>
      </AuthHeader>

      <div className="mt-[30px]">{identityComponent}</div>

      <BottomButtonGroup
        title="인증하기"
        onClick={async () => {
          setIsLoading(true);
          try {
            await changeMemberCertification({
              memberId: user.memberId ?? 0,
              name: identityData.name?.trim() ?? "",
              mobileNumber: identityData.mdn ?? "",
              memberCi: identityData.ci ?? "",
            });
            navigate("/myinfo");
          } catch (e: any) {
            setPopup("certFailed");
          } finally {
            setIsLoading(false);
          }
        }}
        disabled={!isIdentityComplete}
      />
      <CommonPopup
        isOpen={popup === "certFailed"}
        title="본인인증 실패"
        unUseHorizonRule
        padding={0}
        onClose={() => setPopup("")}
      >
        <div className="px-5 pb-5">
          <div className="py-2.5 flex flex-col gap-2.5 items-center">
            <FindIdInfoIcon />
            <div className=" whitespace-pre-line text-center text-brand-neutral-60 text-sm">
              {
                "일부 개인정보를 잘못 입력한 것 같아요.\n이동통신사에 등록한\n이름 생년월일로 입력해주세요"
              }
            </div>
          </div>
        </div>
        <CommonButton
          className="h-bottom-button w-full rounded-none"
          onClick={() => setPopup("")}
        >
          확인
        </CommonButton>
      </CommonPopup>
    </div>
  );
}
